import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgRewards({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2a7 7 0 016.001 10.606L18 20.116a1.5 1.5 0 01-2.128 1.363l-.144-.076-3.213-1.928a1 1 0 00-.907-.063l-.123.063-3.213 1.928a1.5 1.5 0 01-2.263-1.124L6 20.117v-7.51A7 7 0 0112 2zm4 17.234l.001-4.49A6.967 6.967 0 0112 16a6.968 6.968 0 01-4-1.255v4.489l2.457-1.474a3 3 0 012.906-.1l.18.1L16 19.234l.001-4.49-.001 4.49zM12 4a5 5 0 100 10 5 5 0 000-10z"
        fill={color}
      />
    </svg>
  )
}

export default SvgRewards
